import { mq_breakpoints } from './breakpoints'
import lazySizes from 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'

lazySizes.cfg.lazyClass = 'lazyload'

lazySizes.cfg.customMedia = {
  ...mq_breakpoints
}

// Remove placeholder on lazysizes loaded event
document.addEventListener('lazyloaded', e => {
  let parent_node = e.target.parentNode
  if (parent_node.tagName == 'PICTURE') {
    parent_node = parent_node.parentNode
  }
  if (parent_node.classList.contains('lazy-container')) {
    parent_node.classList.remove('lazy-container')
  }
})

// Custom event callback for lazy loading javascript
// https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance
document.addEventListener('DOMContentLoaded', function () {
  let lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'))
  if ('IntersectionObserver' in window) {
    let options = { threshold: 0.10 }

    let lazyElementObserver = new IntersectionObserver(function(entries, options) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyTarget = entry.target
          let event = new Event('elementinview')
          lazyTarget.dispatchEvent(event)
          lazyElementObserver.unobserve(lazyTarget)
        }
      })
    })

    lazyElements.forEach(function (el) {
      lazyElementObserver.observe(el)
    })
  } else {
    console.warn('IntersectionObserver not found. Dispatching all events..')
    let lazyElements = [].slice.call(document.querySelectorAll('.lazyscript'))
    lazyElements.forEach(el => {
      var event = new Event('elementinview')
      el.dispatchEvent(event)
    })
  }
})
